import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginRequiredModal from '../components/LoginRequiredModal';
import { useTranslation } from 'react-i18next';
import CreateCampaign from '../components/CreateCampaign/CreateCampaign';

const NewCampaign = () => {
  const { t } = useTranslation();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const localUserId = localStorage.getItem('user_id');
    const loginTime = localStorage.getItem('login_time');
    const isValid = localUserId && loginTime && (Date.now() - Number(loginTime) < 7 * 24 * 60 * 60 * 1000);

    if (isValid) {
      (async () => {
        try {
          const axios = (await import('axios')).default;
          // 1. 获取user_info
          const userInfoRes = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/user_info`, { user_id: localUserId });
          const userInfo = userInfoRes.data;
          sessionStorage.setItem('userId', localUserId);
          sessionStorage.setItem('userName', userInfo.user_name);
          sessionStorage.setItem('userEmail', userInfo.user_email);
          sessionStorage.setItem('loggedIn', 'true');
          // 2. 获取advertiser信息
          const advRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/advertiser?user_id=${localUserId}`);
          if (advRes.data && advRes.data.advertiser) {
            sessionStorage.setItem('advertiserId', advRes.data.advertiser.advertiser_id);
            sessionStorage.setItem('companyName', advRes.data.advertiser.company_name);
            window.dispatchEvent(new Event('storage'));
          } else {
            throw new Error('No advertiser info');
          }
        } catch (e) {
          localStorage.removeItem('user_id');
          localStorage.removeItem('login_time');
          sessionStorage.clear();
          setShowLoginModal(true);
        }
      })();
    } else {
      localStorage.removeItem('user_id');
      localStorage.removeItem('login_time');
      sessionStorage.clear();
      setShowLoginModal(true);
    }
  }, []);

  const handleLoginRedirect = () => {
    setShowLoginModal(false);
    navigate('/login');
  };

  return (
    <>
      <LoginRequiredModal show={showLoginModal} onLogin={handleLoginRedirect} />
      <CreateCampaign />
    </>
  );
};

export default NewCampaign; 